<template>

        <div>
            <h1 class="text-lg font-semibold mb-3">Video Tutorials</h1>

            <hr class="border-b border-gray-100 mb-3">

              <div class="flex flex-row flex-wrap">
                <div v-if="me && me.isDiy == 1" class="dashboard-box stats-box w-full mb-4 md:w-1/4 lg:w-1/4 mr-4">
                  <v-card
                    class="pa-2"
                    tile
                  >
                    <div class="p-3">
                      <strong>Setup Guide</strong>
                      <p class="text-gray-600 text-sm" style="min-height: 50px; padding-top: 10px;">
                        Exploring the DIY AI Platform: A Quick Setup Guide
                      </p>
                      <iframe width="100%" height="250" src="https://www.loom.com/embed/5b3d2ad5e2b044c59d866617ef4e273b" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    </div>
                  </v-card>
                </div>

                <div class="dashboard-box stats-box w-full mb-4 md:w-1/4 lg:w-1/4 mr-4">
                  <v-card
                    class="pa-2"
                    tile
                  >
                    <div class="p-3">
                      <strong>How to Login to the LSA Dashboard</strong>
                      <p class="text-gray-600 text-sm" style="min-height: 50px; padding-top: 10px;">
                        In this quick video, I'll show you how to login to our LSA Software.
                      </p>
                      <iframe width="100%" height="250" src="https://www.loom.com/embed/b8311b762789482da31bffb279fece42" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    </div>
                  </v-card>
                </div>

                <div class="dashboard-box stats-box w-full mb-4 md:w-1/4 lg:w-1/4 mr-4">
                  <v-card
                    class="pa-2"
                    tile
                  >
                    <div class="p-3">
                      <strong>Where to find the calls and text answered by AI</strong>
                      <p class="text-gray-600 text-sm" style="min-height: 50px; padding-top: 10px;">
                        In this quick video, I'll show you how to locate your calls and message leads in the app's back office.
                      </p>
                      <iframe width="100%" height="250" src="https://www.loom.com/embed/960024a811a34c7ab786501e7d55128a" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    </div>
                  </v-card>
                </div>

                <div class="dashboard-box stats-box w-full mb-4 md:w-1/4 lg:w-1/4 mr-4">
                  <v-card
                    class="pa-2"
                    tile
                  >
                    <div class="p-3">
                      <strong>How to find your or get your username and password? </strong>
                      <p class="text-gray-600 text-sm" style="min-height: 50px; padding-top: 10px;">
                        This video is helpful if you ever lose your username or forgot your password.
                      </p>
                      <iframe width="100%" height="250" src="https://www.loom.com/embed/82898bae9b76468384d165164576a596" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    </div>
                  </v-card>
                </div>

                <div class="dashboard-box stats-box w-full mb-4 md:w-1/4 lg:w-1/4 mr-4">
                  <v-card
                    class="pa-2"
                    tile
                  >
                    <div class="p-3">
                      <strong>How to set up notifications in our software? </strong>
                      <p class="text-gray-600 text-sm" style="min-height: 50px; padding-top: 10px;">
                        Learn how to configure email and SMS notifications to receive important updates from the app.
                      </p>
                      <iframe width="100%" height="315" src="https://www.youtube.com/embed/a_hjRKaUUoI?si=UG3e6w1dJMjsTF6w" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                  </v-card>
                </div>

                <div class="dashboard-box stats-box w-full mb-4 md:w-1/4 lg:w-1/4 mr-4">
                  <v-card
                    class="pa-2"
                    tile
                  >
                    <div class="p-3">
                      <strong>What is A2P compliance for text? </strong>
                      <p class="text-gray-600 text-sm" style="min-height: 50px; padding-top: 10px;">
                        A2P gives you the ability to send SMS messages to your clients. Learn more about it in the video below.
                      </p>
                      <iframe width="100%" height="250" src="https://www.loom.com/embed/6d25712fa31b464f97042ec6542dbaa4" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    </div>
                  </v-card>
                </div>

                <div class="dashboard-box stats-box w-full mb-4 md:w-1/4 lg:w-1/4 mr-4">
                  <v-card
                    class="pa-2"
                    tile
                  >
                    <div class="p-3">
                      <strong>How to fill in your A2P form? </strong>
                      <p class="text-gray-600 text-sm" style="min-height: 50px; padding-top: 10px;">
                        Learn how to fill in your A2P in the video below.
                      </p>
                      <iframe width="100%" height="250" src="https://www.loom.com/embed/42a23bf5ab5f4682b7657b0beb60b397" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    </div>
                  </v-card>
                </div>

                <div class="dashboard-box stats-box w-full mb-4 md:w-1/4 lg:w-1/4 mr-4">
                  <v-card
                    class="pa-2"
                    tile
                  >
                    <div class="p-3">
                      <strong>How to edit your prompt in our software? </strong>
                      <p class="text-gray-600 text-sm" style="min-height: 50px; padding-top: 10px;">
                        In this video, I show you how to edit your text and voice prompt in our software and how to see how the prompt behaves.
                      </p>
                      <iframe width="100%" height="250" src="https://www.loom.com/embed/942915ba95a3400f91b9c2ae6b81f75c" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    </div>
                  </v-card>
                </div>

                <div class="dashboard-box stats-box w-full mb-4 md:w-1/4 lg:w-1/4 mr-4">
                  <v-card
                    class="pa-2"
                    tile
                  >
                    <div class="p-3">
                      <strong>What is a prompt? </strong>
                      <p class="text-gray-600 text-sm" style="min-height: 50px; padding-top: 10px;">
                        In this video I give you insights on what a prompt is and where to find it in our software.
                      </p>
                      <iframe width="100%" height="250" src="https://www.loom.com/embed/6793c2de33cf41acb945a0dc9eb159ab" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    </div>
                  </v-card>
                </div>

                <div class="dashboard-box stats-box w-full mb-4 md:w-1/4 lg:w-1/4 mr-4">
                  <v-card
                    class="pa-2"
                    tile
                  >
                    <div class="p-3">
                      <strong>How to create a LSA Audit? </strong>
                      <p class="text-gray-600 text-sm" style="min-height: 50px; padding-top: 10px;">
                        What the video below to learn how to create a LSA Audit in our software.
                      </p>
                      <iframe width="100%" height="250" src="https://www.loom.com/embed/dd02441a36f745dd91234ab67057c8bf" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    </div>
                  </v-card>
                </div>

                <div class="dashboard-box stats-box w-full mb-4 md:w-1/4 lg:w-1/4 mr-4">
                  <v-card
                    class="pa-2"
                    tile
                  >
                    <div class="p-3">
                      <strong>How to generate service areas with our tool? </strong>
                      <p class="text-gray-600 text-sm" style="min-height: 50px; padding-top: 10px;">
                        Step-by-step guide to mapping service areas and easily define service zones in seconds.
                      </p>
                      <iframe width="100%" height="250" src="https://www.loom.com/embed/2360495b90164489acf90cfab71bf92d" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    </div>
                  </v-card>
                </div>

                <div class="dashboard-box stats-box w-full mb-4 md:w-1/4 lg:w-1/4 mr-4">
                  <v-card
                    class="pa-2"
                    tile
                  >
                    <div class="p-3">
                      <strong>How Rate Your LSA Leads Instantly & Track Feedback</strong>
                      <p class="text-gray-600 text-sm" style="min-height: 50px; padding-top: 10px;">
                        Our software lets you rate your LSA leads instantly, even those under review, and keeps a full record of your feedback.
                      </p>
                      <iframe width="100%" height="250" src="https://www.youtube.com/embed/xR0UMenrzks?si=4bd8o3MhXafYt-6N" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                  </v-card>
                </div>

                <div class="dashboard-box stats-box w-full mb-4 md:w-1/4 lg:w-1/4 mr-4">
                  <v-card
                    class="pa-2"
                    tile
                  >
                    <div class="p-3">
                      <strong>Auto-Tag Leads</strong>
                      <p class="text-gray-600 text-sm" style="min-height: 50px; padding-top: 10px;">
                        Setup triggers to automate specific actions like email notifications or auto-tagging of the leads.
                      </p>
                      <iframe width="100%" height="250" src="https://www.loom.com/embed/ccbe8ab024f344b5bf3d8baf4a81217c" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    </div>
                  </v-card>
                </div>
              </div>
            </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {
    
  },
  computed: {
      ...mapState({
          me: (state) => state.me.me,
      })
  },
}
</script>